module.exports = __webpack_public_path__ + "img/arm-emg.b2ecb1ad.svg";